import { template } from 'lodash-es'

export default class Formatter {
  constructor(brandedI18n) {
    this.i18n = brandedI18n
  }

  interpolate(message, values) {
    const compiled = template(message)
    return [compiled({ branding: this.i18n, ...values })]
  }
}
